"use client"

import { useFraud } from "@/lib/context/FraudContext"
import type { ReactNode } from "react"
import { FraudModal } from "./fraud-modal"

interface FraudProtectionProps {
    children: ReactNode
    showLoadingState?: boolean
}

export function FraudProtection({ children, showLoadingState = true }: FraudProtectionProps) {
    const { isFraudListed } = useFraud()

    return (
        <>
            {/* Always render the page content */}
            <div className={isFraudListed ? "pointer-events-none select-none" : ""}>{children}</div>

            {/* Show fraud modal overlay when fraud is detected */}
            {isFraudListed &&
                <FraudModal isOpen={true} />
            }
        </>
    )
}
